import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportTasksSummary_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportTasksSummary extends Report<ReportTasksSummary_Settings> {

    static reportName: string = "Tasks summary by project"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_TASK_SUMMARY
        super(data);

        this.icon         = "isvg-summary-by-project"
        // this.description  = "Provides an overview of tasks within a specific project, helping to monitor progress, workload, and overall project performance."
        this.description  = "Provides an overview of tasks within a specific project, helping to track progress and evaluate project performance."

        this.settings     = new ReportTasksSummary_Settings(data.settings)
    }

    static initFromSavedView(savedView:SavedView):ReportTasksSummary {
        return new ReportTasksSummary(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportTasksSummary_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }


    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)

        this.settings.projectId = projectId
    }

    save(){
        console.log("Not implemented")
    }
}
